import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { DisplayErrorLogComponent } from '../pages/common/display-errorlog/display-errorlog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public needToShowLoader: boolean = true;
  // Lacal Server base URL
  public APIBASEURL: string;
  loginData: any;
  createdSalesHeader: any;
  getmembershipdata: any;
  isUserClickedOnBookMem: any;
  countOfLoop = 0;
  tokenaccess: any;
  getGeneratedToken: any;
  getLocalStorageData: any;
  userLoginData: any;
  private tokenTimer!: Subscription;
  constructor(
    private httpClient: HttpClient,
    public spinner: NgxSpinnerService,
    public common: CommonService,
    private modalService: NgbModal,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.APIBASEURL = baseUrl;
  }
  // API Error handler Method
  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
  //Post response  or push data by Post method
  async postAPICallWithoutToken(APIEndpoint: string, formData: any): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-type': 'application/json',
        'Key': "e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD",
        Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
      })
    };
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        //var api = APIEndpoint.split('/')[2];
        //this.common.showToastMessage('Something Went Worng.Please Try Again Later', 2);
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
          if(errorObj.errorMessage == null || errorObj.errorMessage == undefined || !errorObj.errorMessage){
            errorObj.errorMessage = err.error.message;
          }
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        this.spinner.hide();
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        //this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
        this.common.error = true;
        this.spinner.hide();
      }
      );
    })
  }
  async PutApiCall(APIEndpoint: string, formData: any): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-type': 'application/json',
        'Key': "e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD",
        Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
      })
    };
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.put(environment.BaseUrl  + APIEndpoint, formData, httpOptions).subscribe(res => {
        //var api = APIEndpoint.split('/')[2];
        //this.common.showToastMessage('Something Went Worng.Please Try Again Later', 2);
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        this.spinner.hide();
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        //this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
        this.common.error = true;
        this.spinner.hide();
      }
      );
    })
  }
  async DeleteApiCall(APIEndpoint: string): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-type': 'application/json',
        'Key': "e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD",
        Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
      })
    };
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.delete(environment.BaseUrl  + APIEndpoint, httpOptions).subscribe(res => {
        //var api = APIEndpoint.split('/')[2];
        //this.common.showToastMessage('Something Went Worng.Please Try Again Later', 2);
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        this.spinner.hide();
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        //this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
        this.common.error = true;
        this.spinner.hide();
      }
      );
    })
  }
  //Get response  or push data by Post method
  async getAPICallWithoutToken(APIEndpoint: string): Promise<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-type': 'application/json',
        'Key': "e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD",
        Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
      })
    };
    // httpOptions.headers.append('Key','e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD');
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `GET` request that interprets the body as a JSON object
      this.spinner.show();
      this.httpClient.get(this.APIBASEURL + APIEndpoint, httpOptions).subscribe(res => {
        //var api = APIEndpoint.split('/')[2];
        //this.common.showToastMessage(api + '- Something Went Wrong . Please contact Administrator !', 2);
        resolve(res);
        this.spinner.hide();
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        }); this.spinner.hide();
        //console.warn("APIEndpoint ", APIEndpoint, " err ", err);
      }
      );
    })
  }

  async getAPICall(APIEndpoint: string, formData: any, hideLoader: boolean = true): Promise<any> {
    /** spinner starts on init */
    await this.spinner.show();
    //Creates a new Promise.
    return new Promise<any>((resolve, reject) => {
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.get(environment.BaseUrl + APIEndpoint, formData).subscribe(res => {
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " result ", res);
        //var api = APIEndpoint.split('/')[1];
        //this.common.showToastMessage(api + 'Something Went Wrong . Please contact Administrator !', 2);
        if (hideLoader) {
          // this.spinner.hide();
        }
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        this.spinner.hide();
        reject(err);
      }
      );
    })
  }


  //Post response  or push data by Post method
  async PersonInqUnifiedNumberAPICall(APIEndpoint: string, formData: any): Promise<any> {
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object
      let userLoginInfo = this.common.getValueFromSessionStorage('userLoginInfo');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
        })
      };
      this.spinner.show();
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        resolve(res);

      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        }); this.spinner.hide();
        console.warn("APIEndpoint ", APIEndpoint, " err ", err);
      }
      );
    })
  }


  //Post response  or push data by Post method
  async postAPICallWithToken(APIEndpoint: string, formData: any, hideLoader: boolean = true): Promise<any> {

    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object

      let token = this.common.getValueFromSessionStorage('smartAccessTokenForSession');
      /*if (token == null) {
        (async (): Promise<void> => {
          let res = await this.httpClient.post<any>("api/EnquiryManager/SmartGenerateToken", {}).toPromise();
          token = res.access_token;
          this.common.setValueToSessionStorage('smartAccessTokenForSession', token);
        })();

      }*/

      const httpOptions = {
        headers: new HttpHeaders({
          // 'Content-type': 'application/json',
          'Key': 'e4aKIOSKjUjZttXJkWnZCwc1t0eDLTrUPYdhd2W4ybrJW9XR4bl3jwBP0av2WXT5rBHsD',
          Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
        })
      };
      this.spinner.show();
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        //var api = APIEndpoint.split('/')[2];
        //this.common.showToastMessage(api + '- Something Went Wrong . Please contact Administrator !', 2);
        if (hideLoader) {
          this.spinner.hide();
        }
        //console.log("APIEndpoint ", APIEndpoint, " formData ", formData , " res ", res);
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        this.spinner.hide();
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        this.spinner.hide();
        //console.warn("APIEndpoint ", APIEndpoint, " err ", err);
      }

      );
    })
  }
  // For Enquiry token Start

  //Post response  or push data by Post method
  async postEnquiryAPICallWithToken(APIEndpoint: string, formData: any, hideLoader: boolean = true): Promise<any> {

    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object

      let token = this.common.getValueFromSessionStorage('enquiryAccessToken');
      //console.log("token ", token);
      if (token == null) {
        (async (): Promise<void> => {
          let res = await this.httpClient.post<any>("api/EnquiryManager/GenerateToken", {}).toPromise();
          token = res.access_token;
          this.common.setValueToSessionStorage('enquiryAccessToken', token);
        })();

      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
        })
      };
      this.spinner.show();
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        if (hideLoader) {
          this.spinner.hide();
        }
        //console.log("APIEndpoint ", APIEndpoint, " res ", res);
        resolve(res);
      }, err => {
        //console.warn("APIEndpoint ", APIEndpoint, " err ", err);
        if (err.status == 401) {
          this.spinner.show();
          this.httpClient.post("api/EnquiryManager/GenerateToken", formData).subscribe((resGen: any) => {
            token = resGen.access_token;
            this.common.setValueToSessionStorage('enquiryAccessToken', token);
            const httpOptionsRed = {
              headers: new HttpHeaders({
                'Content-type': 'application/json',
                Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
              })
            };
            this.spinner.show();
            this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptionsRed).subscribe(res => {
              if (hideLoader) {
                this.spinner.hide();
              }
              resolve(res);
            }, err => {
              this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
              if (hideLoader) {
                this.spinner.hide();
              }
              reject(err);
            });

          }, err => {
            this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
            if (hideLoader) {
              this.spinner.hide();
            }
            reject(err);
          }
          );

        } else {
          // If 400 / 500 / 0 error occurs while calling API then showing that error Message
          this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
          if (hideLoader) {
            this.spinner.hide();
          }
          reject(err);
        }
      }
      );
    })
  }
  // For Enquiry token end
  //Post response  or push data by Post method
  async postAPICallforLetterwithToken(APIEndpoint: string, token: any, formData: any, hideLoader: boolean = true): Promise<any> {
    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
        })
      };
      this.spinner.show();
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " result ", res);
        if (hideLoader) {
          this.spinner.hide();
        }
        resolve(res);
      }, err => {
        // Check Type of the Error
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " Error ", err);
        this.spinner.hide();
        if (APIEndpoint.indexOf('UserRegistration') == -1) {
          this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
        }
        reject(err);

      }
      );
    })
  }

  //Post response  or push data by Post method
  async postAPICallforRefreshToken(APIEndpoint: string, token: any, formData: any): Promise<any> {

    //Creates a new Promise.
    return await new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-type': 'application/json',
          Authorization: 'Basic ' + btoa(this.common.Username + ':' + this.common.Password)
        })
      };

      //this.spinner.show();
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " result ", res);

        resolve(res);
      }, err => {
        // Check Type of the Error
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " Error ", err);
        //this.spinner.hide();
        this.common.showToastMessage('Something Went Wrong . Please contact Administrator !', 2);
        reject(err);

      }
      );
    })
  }
  //Abhijith Post API with GetAccessToken
  async postAPICallwithGetAccessToken(APIEndpoint: string, formData: any, getAccesstoken: string): Promise<any> {
    /** spinner starts on init */
    //Creates a new Promise.
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'authorization': 'OAuth 2.0 ' + getAccesstoken,
          'accept': 'application/json',
          'Content-Type': 'application/json'
        })
      };
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.post(this.APIBASEURL + APIEndpoint, formData, httpOptions).subscribe(res => {
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        }); reject(err)
      }
      );
    })
  }

  //Post response  or push data by Post method
  async postAPICall(APIEndpoint: string, formData: any, hideLoader: boolean = true): Promise<any> {
    /** spinner starts on init */
    await this.spinner.show();
    //Creates a new Promise.
    return new Promise<any>((resolve, reject) => {
      this.spinner.show();
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.post(environment.BaseUrl + APIEndpoint, formData).subscribe(res => {
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " result ", res);
        //var api = APIEndpoint.split('/')[1];
        //this.common.showToastMessage(api + 'Something Went Wrong . Please contact Administrator !', 2);
        if (hideLoader) {
          // this.spinner.hide();
        }
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        this.spinner.hide();
        reject(err);
      }
      );
    })
  }

  //Post response  or push data by Post method
  async postAPICallWithoutLoader(APIEndpoint: string, formData: any, hideLoader: boolean = true): Promise<any> {
    //Creates a new Promise.
    return new Promise<any>((resolve, reject) => {
      //Constructs a `POST` request that interprets the body as a JSON object
      this.httpClient.post(environment.BaseUrl + APIEndpoint, formData).subscribe(res => {
        //console.log("APIEndpoint", APIEndpoint, " formData ", formData, " result ", res);
        //var api = APIEndpoint.split('/')[1];
        //this.common.showToastMessage(api + 'Something Went Wrong . Please contact Administrator !', 2);
        if (hideLoader) {
          // this.spinner.hide();
        }
        resolve(res);
      }, err => {
        let errorObj: any = {};
        /*Display the API Name if it throws an error, Abhijith 03-11-2023 */
        let APIName = err.url.split("/").pop();

        /*Catagories the API's which belongs to CRM, Retail, BANK POS and EID, Abhijith 04-11-2023 */
        if (this.common.RetailAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "Retail API's";
          errorObj.errorMessage = err.error.Message;
        }
        else if (this.common.BANKPosAPIs.includes(APIName)) {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "BANK POS API's";
          errorObj.errorMessage = err.error.Message;
        }
        else {
          errorObj.errorAPIName = APIName;
          errorObj.apiCategory = "CRM API's";
          errorObj.errorMessage = err.error.Message;
        }
        this.common.setValueToSessionStorage("ErrorLog", JSON.stringify(errorObj));
        const modalRef = this.modalService.open(DisplayErrorLogComponent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'alert_modal_popup logout_popup' }).result.then((result) => {
        }, (reason) => {
        });
        this.spinner.hide();
        reject(err);
      }
      );
    })
  }
  
  downloadFile(url: string): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(url, { responseType: 'blob', observe: 'response' }).pipe(
      map(response => response)
    );
  }
  async getTokenAccess() {
    let data = {
      client_id: this.common.client_id,
      client_secret: this.common.client_secret,
      grant_type: this.common.grant_type,
      resource: this.common.resource,
    }
    this.spinner.show();
    await this.postAPICallWithoutToken('api/ActivityManager/GetTokenAccessToCallAffiliationList', data).then(async result => {

      if (result != null) {
        let data = JSON.parse(result.ResponseMessage);
        this.common.setValueToSessionStorage("getGeneratedToken", data.access_token) ;
      }
      this.spinner.hide();
      this.common.isPageLoad = true;
    }).catch(error => {
      console.log("error ", error);
      this.spinner.show();
    });
  }
  private checkAndRefreshToken() {
    const accessToken = sessionStorage.getItem('getGeneratedToken');
    if (accessToken) {
      console.log("With login");
      this.getTokenAccess();
    }
    else {
      console.log("Without login");
    }
  }
  startTokenCheck() {
    if (this.tokenTimer) {
      this.tokenTimer.unsubscribe();
    }
    this.tokenTimer = interval(50 * 60 * 1000).subscribe(() => {
      this.checkAndRefreshToken();
    });
    this.checkAndRefreshToken();
  }
  stopTokenCheck() {
    if (this.tokenTimer) {
      this.tokenTimer.unsubscribe();
    }
  }
}
